export default __webpack_public_path__ + "static/media/S-008.014bda69.png";